const e = {
  name: "CheckmarkCircleFill",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM17.9144 9.00003L16.5002 7.58582L10.5002 13.5858L7.50015 10.5858L6.08594 12L10.5002 16.4142L17.9144 9.00003Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as CheckmarkCircleFill
};
